$(function () {
    //---------- footer cart positioning ----------
    function checkOffset() {
        let $footerCartInfo = $('.footer-cart-info');
        let $footer = $('footer');
        if ($footerCartInfo.offset().top + $footerCartInfo.height() >= $footer.offset().top - 10) {
            $footerCartInfo.css('position', 'relative');
        }
        if ($(document).scrollTop() + window.innerHeight < $footer.offset().top) {
            $footerCartInfo.css('position', 'fixed'); // restore when you scroll up
        }
    }

    if ($('.footer-cart-info').length > 0) {
        $(document).scroll(function () {
            checkOffset();
        });
    }
});